import { createFileRoute } from "@tanstack/react-router";
import {
  CompaniesScreen,
  type CompaniesSearch,
  type CompanyKind,
  type PlanFilter,
} from "../screens/staff/CompaniesScreen.tsx";

/**
 * `/sysadmin`: every company. The search, plan and kind filters go to the database function; the address keeps them,
 * so a link to "pro companies" works.
 */
const PLANS: PlanFilter[] = ["free", "start", "pro", "business"];
const KINDS: CompanyKind[] = ["demo", "all"];

export const Route = createFileRoute("/_staff/sysadmin/")({
  validateSearch: (search: Record<string, unknown>): CompaniesSearch => ({
    ...(typeof search.q === "string" && search.q.length < 80 && search.q ? { q: search.q } : {}),
    ...(PLANS.includes(search.plan as PlanFilter) ? { plan: search.plan as PlanFilter } : {}),
    ...(KINDS.includes(search.kind as CompanyKind) ? { kind: search.kind as CompanyKind } : {}),
  }),
  component: CompaniesScreen,
});
